import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const SEND_FOR_APPROVAL = gql`
  ${DEDUCTION_FRAGMENT}
  mutation SendApproval($params: SendApprovalParams!) {
    sendForApproval(params: $params) {
      ...DeductionFields
    }
  }
`;

export default SEND_FOR_APPROVAL;